var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxOnclick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.189 15.5918C9.6646 16.124 8.8083 16.124 8.28394 15.5918L5.20513 12.4668C4.67932 11.9346 4.67932 11.0654 5.20513 10.5332C5.72949 10.001 6.58578 10.001 7.11014 10.5332L9.23645 12.6914L14.4416 7.4082C14.9659 6.87598 15.8222 6.87598 16.3466 7.4082C16.871 7.94043 16.871 8.80957 16.3466 9.3418L10.189 15.5918ZM0 3.6875C0 1.96143 1.37825 0.5625 3.07882 0.5625H18.4729C20.1711 0.5625 21.5517 1.96143 21.5517 3.6875V19.3125C21.5517 21.0361 20.1711 22.4375 18.4729 22.4375H3.07882C1.37825 22.4375 0 21.0361 0 19.3125V3.6875ZM2.30911 3.6875V19.3125C2.30911 19.7422 2.65356 20.0938 3.07882 20.0938H18.4729C18.8962 20.0938 19.2426 19.7422 19.2426 19.3125V3.6875C19.2426 3.25586 18.8962 2.90625 18.4729 2.90625H3.07882C2.65356 2.90625 2.30911 3.25586 2.30911 3.6875Z",
    fill: "url(#paint0_linear_44_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_218",
    x1: 10.7759,
    y1: 0.5625,
    x2: 10.7759,
    y2: 22.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B779F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOnclick);
export default __webpack_public_path__ + "static/media/checkbox-onclick.a3c59e0ee3163957af029047b8a51fa1.svg";
export { ForwardRef as ReactComponent };